export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=template&id=b1141f10&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/Dashboard.vue?vue&type=template&id=b1141f10&scoped=true
// module id = 67BN
// module chunks = 41